import { Component, OnInit, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
//import {TabsModule} from 'ngx-bootstrap';

@Component({
  selector: 'app-style-guide',
  templateUrl: './style-guide.component.html',
  styleUrls: ['./style-guide.component.css']
})
export class StyleGuideComponent implements OnInit {

  @ViewChild('tabsID',{static: false}) tabsID;

  selectTab(tabId: number) {
    this.tabsID.tabs[tabId].active = true;
  }

  constructor() { }

  ngOnInit() {
    if (history.state.data && history.state.data.requestId) {
      // console.log("request Id : " + history.state.data.requestId);
    }
  }
}
